// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog(theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.secondary.lighter,
          backgroundImage: 'none',
          border: `1px solid ${theme.palette.secondary.dark}`,
          borderRadius: '4px',
          boxShadow: '-3px 0px 10px 0px #00000080, -1px -1px 1px 0px #D5D5EB1A',
          '& .MuiCardHeader-root': {
            color: theme.palette.text.primary,
            height: theme.spacing(6),
          },
        },
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: theme.palette.dialog.backDropColor,
          },
          '& .MuiDialogTitle-root': {
            borderBottom: `1px solid ${theme.palette.secondary.dark}`,
            height: 'auto',
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.secondary.light,
            '& .MuiButtonBase-root': {
              color: theme.palette.text.secondary,
            },
          },
        },
      },
    },
  }
}
